(() => {
  if (window.aurelineIpFlagInitialized) return;
  window.aurelineIpFlagInitialized = true;
  const cacheKey = 'aureline_ip_country_v1';
  const cacheAge = 30 * 60 * 1000;
  let countryPromise;

  function validCode(value) {
    return typeof value === 'string' && /^[A-Z]{2}$/.test(value) && value !== 'XX' && value !== 'ZZ';
  }

  function readCache() {
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey));
      if (cached && validCode(cached.code) && Date.now() - cached.time < cacheAge) return cached.code;
    } catch {}
    return null;
  }

  function getCountry() {
    if (countryPromise) return countryPromise;
    const cached = readCache();
    if (cached) {
      countryPromise = Promise.resolve(cached);
      return countryPromise;
    }
    countryPromise = (async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 5000);
      try {
        const response = await fetch('https://ipapi.co/json/?key=NzbsJtCID6vQvMqSt5tfClpwk0ow27FGtJ3TYaHXwHr7ZVCirh', {
          signal: controller.signal,
          credentials: 'omit'
        });
        if (!response.ok) return null;
        const data = await response.json();
        const code = typeof data.country_code === 'string' ? data.country_code.toUpperCase() : '';
        if (data.error || !validCode(code)) return null;
        try {
          sessionStorage.setItem(cacheKey, JSON.stringify({ code, time: Date.now() }));
        } catch {}
        return code;
      } catch {
        return null;
      } finally {
        clearTimeout(timeout);
      }
    })();
    return countryPromise;
  }

  async function updateFlags() {
    if (!document.querySelector('[data-aureline-ip-flag]')) return;
    const code = await getCountry();
    if (!code) return;
    const flag = String.fromCodePoint(...Array.from(code, letter => 127397 + letter.charCodeAt(0)));
    document.querySelectorAll('[data-aureline-ip-flag]').forEach(element => {
      element.textContent = flag;
    });
  }

  document.addEventListener('aureline:shipping-ready', updateFlags);
  document.addEventListener('shopify:section:load', updateFlags);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateFlags, { once: true });
  } else {
    updateFlags();
  }
})();
